module.exports = __webpack_public_path__ + "static/media/checkedEclipse2.7d09a70d.svg";